import React, { useState } from 'react';
import { useConditionsStateSnapshot } from 'store/storeValtio';
import ConfirmModal from '../common/ConfirmModal';
import { formatTime } from 'helpers/generalHelpers';

export default function ConditionHistory() {
  const [popup, setPopup] = useState({ show: false, id: null, });
  const conditionsState = useConditionsStateSnapshot();

  const handleDelete = (c) => {
    console.log('handleDelete', c);
    const t = formatTime(c.date);
    setPopup({ show: true, medName: 'condition', taken: t, id: c.id });
    //setIsOpen(true);
  };

  const handleDeleteTrue = () => {
    console.log('handleDeleteTrue', popup.id);
    //handleDeleteHist(popup.id);
  };

  const handleDeleteFalse = () => {
    console.log('handleDeleteFalse');
    setPopup({ show: false, taken: null, id: null });
  };

  return (
    <div>
      <div className='mcard'>
        {/* <div className='mcard-header'>Medication History</div> */}
        <div className='lcard'>
          <div>
            <ConfirmModal
              open={popup.show}
              onConfirm={() => handleDeleteTrue()}
              onCancel={() => handleDeleteFalse()}
              title={popup.medName}
              content={popup.taken}
            />

            {conditionsState.conditions.map((c, ix) => {
              const t = formatTime(c.date);

              return (
                <div className='mcard border-2 border-gray-200 mb-1' key={ix}>
                  <div className='mcard-header'>{t}</div>
                  <div className='histItem'>
                    <div>
                      {c.type}
                      <br />
                      {c.condition}
                    </div>
                    <button
                      onClick={() => handleDelete(c)}
                      className='histItemBtn bg-red-700'
                    >
                      Delete
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
          <div style={{ height: '60px' }} />
        </div>
      </div>
    </div>
  );
}
